import React from "react";
import "./designationDropdown.css";

const DesignationDropdown = ({ levels, selectedLevel, onSelect }) => {
  return (
    <div className="designation-dropdown">
      <select
        value={selectedLevel}
        onChange={(e) => onSelect(e.target.value)}
        className="designation-select"
      >
        <option value="">My Rank</option>
        {levels.map((level) => (
          <option key={level.code} value={level.code}>
            {level.designationGroup}
          </option>
        ))}
      </select>
    </div>
  );
};

export default DesignationDropdown;
